import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;
const PUBLIC = `${process.env.REACT_APP_BACKEND_URL}/api`;

const cli = axios.create({ baseURL: BASE, withCredentials: true });

// Password
export const changeMyPassword = (current_password, new_password) =>
  cli.post("/me/password", { current_password, new_password }).then((r) => r.data);

// Serviços
export const updateServico = (slug, patch) => cli.patch(`/servicos/${slug}`, patch).then((r) => r.data);
export const reorderServicos = (ordem) => cli.post("/servicos/reorder", { ordem }).then((r) => r.data);

// Clientes
export const listarClientes = (params) => cli.get("/clientes", { params }).then((r) => r.data);
export const detalheCliente = (id) => cli.get(`/clientes/${id}`).then((r) => r.data);
export const apagarCliente = (id) => cli.delete(`/clientes/${id}`).then((r) => r.data);

// Médicos
export const listarMedicos = () => cli.get("/medicos").then((r) => r.data);
export const criarMedico = (data) => cli.post("/medicos", data).then((r) => r.data);
export const atualizarMedico = (id, data) => cli.patch(`/medicos/${id}`, data).then((r) => r.data);
export const apagarMedico = (id) => cli.delete(`/medicos/${id}`).then((r) => r.data);

// Disponibilidades
export const listarDisponibilidades = (medico_id) =>
  cli.get("/disponibilidades", { params: medico_id ? { medico_id } : {} }).then((r) => r.data);
export const criarDisponibilidade = (data) => cli.post("/disponibilidades", data).then((r) => r.data);
export const apagarDisponibilidade = (id) => cli.delete(`/disponibilidades/${id}`).then((r) => r.data);

// Bloqueios
export const listarBloqueios = () => cli.get("/bloqueios").then((r) => r.data);
export const criarBloqueio = (data) => cli.post("/bloqueios", data).then((r) => r.data);
export const notificarBloqueio = (id) => cli.post(`/bloqueios/${id}/notificar`).then((r) => r.data);
export const apagarBloqueio = (id) => cli.delete(`/bloqueios/${id}`).then((r) => r.data);

// Utilizadores
export const listarUtilizadores = () => cli.get("/utilizadores").then((r) => r.data);
export const convidarUtilizador = (data) => cli.post("/utilizadores/convidar", data).then((r) => r.data);
export const alternarAtivo = (id) => cli.patch(`/utilizadores/${id}/ativar`).then((r) => r.data);
export const resetConvite = (id) => cli.post(`/utilizadores/${id}/reset-invite`).then((r) => r.data);

// Public — setup password
const publicCli = axios.create({ baseURL: `${PUBLIC}/setup` });
export const checkInvite = (token) => publicCli.get(`/check/${token}`).then((r) => r.data);
export const setupPassword = (token, password) => publicCli.post("/password", { token, password }).then((r) => r.data);
